<template>
  <v-ons-page>
    <div class="page__background" style="background-color: white" />
    <common-header>
      <template #header>
        <Button modifier="quiet" class="backButton" @click="toHome">
          <v-ons-icon icon="md-chevron-left" />
        </Button>
        <span>コンテンツの管理</span>
      </template>
    </common-header>

    <ja-content
      class="contents"
      :contents="contents"
      :getContents="getContents"
      v-show="displayState === DISPLAYSTATE.LOADING_DONE"
    />

    <progress-circular v-show="displayState === DISPLAYSTATE.LOADING_PROGRESS" />

    <common-footer class="common-footer d-flex">
      <template #footer>
        <div class="addButton">
          <small-button
            title="コンテンツを追加する"
            class="smallButton"
            @click="moveTemplateSelect"
          />
        </div>
      </template>
    </common-footer>
  </v-ons-page>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';

import CommonHeader from '@/components/common/CommonHeader.vue';
import CommonFooter from '@/components/common/CommonFooter.vue';
import SmallButton from '@/components/common/SmallButton.vue';
import ProgressCircular from '@/components/common/ProgressCircular.vue';
import JaContent from '@/components/JaContent/JaContent.vue';
import Button from '@/components/common/Button.vue';
import { dataFetchContents } from '@/composable/data_fetch_common';

// 画面遷移用
const router = useRouter();

// ローディング状態Enumを定数で管理
const DISPLAYSTATE = {
  LOADING_PROGRESS: 'ロード中',
  LOADING_DONE: 'ロード完了',
};

// state: コンテンツリストとローディング状態
const contents = ref([]); // コンテンツ一覧
const isLoadingDone = ref(false); // ローディングフラグ

// 画面表示状態のcomputed
const displayState = computed(() => {
  return isLoadingDone.value ? DISPLAYSTATE.LOADING_DONE : DISPLAYSTATE.LOADING_PROGRESS;
});

// コンテンツ取得処理
const getContents = async () => {
  isLoadingDone.value = false;
  const result = await dataFetchContents();
  contents.value = Array.isArray(result) ? result : []; // null/undefined対策
  isLoadingDone.value = true;
};

// 戻るボタン押下時の遷移
const toHome = () => {
  router.push('/ja/home');
};

// テンプレート選択遷移
const moveTemplateSelect = () => {
  router.push('/ja/content/templateSelect');
};

// 初期データ取得
onMounted(() => {
  getContents();
});
</script>
<style scoped>
.contents {
  background-color: #fff;
  padding-top: 10vh;
  padding-bottom: 10vh;
  z-index: 1;
}
.backButton {
  background: transparent;
  border: #fff;
  color: #aaaaaa;
  font-size: 4rem;
  left: 2rem;
  position: absolute;
}
.addButton {
  background: #21963b;
  box-shadow: 0rem 0.2rem #13822c;
  border-radius: 10px;
  color: #fff;
  font-size: 2rem;
  font-weight: bold;
  height: 60%;
  position: absolute;
  text-align: center;
  width: 80%;
  padding: 0;
}
.smallButton {
  padding: 1rem;
}
.smallButton:hover {
  opacity: 0.8;
}
.common-footer {
  height: 9rem;
  flex-direction: column;
}
</style>
